import { GameVars } from "../GameVars";
import { ChallengeState } from "./ChallengeState";
import { GameConstants } from "../GameConstants";
import { Piece } from "../board/Piece";
import { Board } from "../board/Board";
import { GameManager } from "../GameManager";

export class ChallengeManager {

    private static game: Phaser.Game;

    private static promotionEndPosition: string;
    private static p4State: P4State;
    private static p4Object: any;
    private static kingInCheck: boolean;
    private static i: number;

    public static init (game: Phaser.Game): void {

        GameManager.loadRewardedAd();

        this.game = game;

        GameVars.challenge = true;
        GameVars.selectedPiece = null;
        ChallengeManager.i = 1;

        ChallengeManager.kingInCheck = false;
        ChallengeManager.promotionEndPosition = null;

        let levelData = GameVars.problemsData[GameVars.currentLevel];

        GameVars.fen = levelData.fen;
        GameVars.levelMoves = levelData.moves;

        // BoardManager.pushFenHistory();

        ChallengeManager.p4State = p4_fen2state(GameVars.fen);

        GameVars.chess.load(GameVars.fen);

        GameVars.colorPlayer = GameVars.getCurrentTurn();

        ChallengeState.currentInstance.setBoard();

        GameVars.difficulty = GameConstants.DIFFICULTY_HARD;

        GameVars.useBotHint = true;
        GameVars.hintPos = 0;

        let mins = Math.round(((Date.now() / 1000 - GameVars.gameData.lastTimestamp / 1000)) / 60);

        GameVars.gameData.numHints = Math.min(GameVars.gameData.numHints + Math.floor(mins / GameConstants.TIME_HINT) , GameConstants.MAX_HINTS);
    }

    public static startGame(): void {

        // determinar de quien es el turno en base al FEN
        ChallengeManager.setTurn();

        if (GameVars.currentTurn === GameConstants.WHITE) {
            GameVars.hintPos--;
        }

        let board = ChallengeState.currentInstance.board;
        board.newTurn();
    }

    public static pieceSelected(piece: Piece): void {

        if (GameVars.selectedPiece) {
            GameVars.selectedPiece.unselect();
        }

        GameVars.selectedPiece = piece;

        const board: Board = piece.board;

        const validMoves: string[] = GameVars.chess.moves({square: piece.p});

        for (let i: number = 0, ln: number = validMoves.length; i < ln; i++) {
            validMoves[i] = GameVars.getBoardPosition(validMoves[i]);
        }

        board.clearMarkers();
        board.showMarkers(validMoves);
    }

    public static removeHintButton(): void {
        ChallengeState.currentInstance.gui.removeHint();
    }

    public static updateHints(): void {

        let mins = Math.round(((Date.now() / 1000 - GameVars.gameData.lastTimestamp / 1000)) / 60);

        if (mins >= GameConstants.TIME_HINT && GameVars.gameData.numHints < GameConstants.MAX_HINTS) {
            GameVars.gameData.numHints++;
            GameVars.gameData.lastTimestamp = Date.now();
        }

    }

    public static useHint(): void {

        // AQUI ENSEÑAR EL VIDEO ANTES

        GameVars.gameData.numHints--;
        GameVars.gameData.lastTimestamp = Date.now();
        GameManager.saveGameData();

        if (GameVars.currentTurn === GameVars.colorPlayer) {
            GameVars.levelMoves --;  
            ChallengeState.currentInstance.hud.updateMoves();
        }

        ChallengeState.currentInstance.gui.disableHint();

        let hints = GameVars.problemsData[GameVars.currentLevel].hints;

        let color = GameVars.colorPlayer === GameConstants.WHITE ? 0 : 1;

        let moveString = hints[GameVars.hintPos][color];

        let m: Move = GameVars.chess.move(moveString);

        let board: Board = ChallengeState.currentInstance.board;
        
        GameVars.selectedPiece = board.getPieceAt(m.from);

        // unselect all pieces
        GameVars.selectedPiece.select();

        ChallengeManager.game.time.events.add(1500, function(): void {

            for (let i = 0; i < board.pieces.length; i++) {
                board.pieces[i].unselect();
            }

            let pawnPromotion: boolean = ChallengeManager.checkPawnPromotion(m.to);

            if (pawnPromotion) {

                ChallengeManager.promotionEndPosition = m.to;

                // ver si se ha capturado alguna pieza
                let capturedPiece = board.getPieceAt(m.to);
                
                if (capturedPiece) {

                    board.removePiece(capturedPiece);
                    GameVars.capturedPieces.push(capturedPiece.pieceType);        
                }

                board.clearMarkers();
                GameVars.selectedPiece.unselect();
                GameVars.selectedPiece.moveToPromotionPosition(m.to);
                ChallengeState.currentInstance.showPawnPromotionMenu();

            } else {
                
                ChallengeManager.p4State.move(GameVars.selectedPiece.p, m.to);

                // ver si se ha capturado alguna pieza
                ChallengeManager.checkIfPieceHasBeenCaptured(m, m.to);

                board.clearMarkers();
                board.moveSelectedPiece(m);
            }

            // hints
            if (m.san) {

                let hints = GameVars.problemsData[GameVars.currentLevel].hints;

                let color = GameVars.colorPlayer === GameConstants.WHITE ? 0 : 1;

                if (m.san !== hints[GameVars.hintPos][color]) {   
                    GameVars.useBotHint = false;
                }
            } else {
                GameVars.useBotHint = false;
            }
        }, ChallengeManager);
        
    }

    public static movePlayerSelectedPiece(endPosition: string): void {

        if (GameVars.currentTurn === GameVars.colorPlayer) {
            GameVars.levelMoves --;  
            ChallengeState.currentInstance.hud.updateMoves();
        }

        let board: Board = ChallengeState.currentInstance.board;
        
        let pawnPromotion: boolean = ChallengeManager.checkPawnPromotion(endPosition);

        // notificar a chess
        let m: Move = {from: GameVars.selectedPiece.p, to: endPosition};

        if (pawnPromotion) {

            ChallengeManager.promotionEndPosition = endPosition;

            // ver si se ha capturado alguna pieza
            let capturedPiece = board.getPieceAt(endPosition);
            
            if (capturedPiece) {

                board.removePiece(capturedPiece);
                GameVars.capturedPieces.push(capturedPiece.pieceType);        
            }

            board.clearMarkers();
            GameVars.selectedPiece.unselect();
            GameVars.selectedPiece.moveToPromotionPosition(endPosition);
            ChallengeState.currentInstance.showPawnPromotionMenu();

        } else {

            m = GameVars.chess.move(m);
            
            ChallengeManager.p4State.move(GameVars.selectedPiece.p, endPosition);

            // ver si se ha capturado alguna pieza
            ChallengeManager.checkIfPieceHasBeenCaptured(m, endPosition);

            board.clearMarkers();
            board.moveSelectedPiece(m);

        }

        // hints
        if (m.san) {

            let hints = GameVars.problemsData[GameVars.currentLevel].hints;

            let color = GameVars.colorPlayer === GameConstants.WHITE ? 0 : 1;

            if (m.san !== hints[GameVars.hintPos][color]) {   
                GameVars.useBotHint = false;
            }
        } 
    }

    public static promotionPieceSelectedByPlayer(promotedPiece: string): void {

        ChallengeState.currentInstance.removePawnPromotionLayer();

        let startPosition: string = GameVars.selectedPiece.p;

        // notificar a chess
        GameVars.chess.move({from: startPosition, to: ChallengeManager.promotionEndPosition, promotion: promotedPiece});

        // cambiar el tipo de la pieza
        // para la promocion chess usa minusculas
        let promotion: number;

        if (promotedPiece === GameConstants.BLACK_ROOK) {
            promotion = 4;
        }

        if (promotedPiece === GameConstants.BLACK_KNIGHT) {
            promotion = 6;
        }

        if (promotedPiece === GameConstants.BLACK_BISHOP) {
            promotion = 8;
        }

        if (promotedPiece === GameConstants.BLACK_QUEEN) {
            promotion = 12;
        }

        // notificar al p4
        ChallengeManager.p4State.move(startPosition, ChallengeManager.promotionEndPosition, promotion);

        ChallengeManager.game.time.events.add(450, function(): void {
            GameVars.selectedPiece.promoteTo(promotedPiece);
        }, ChallengeManager);

        GameVars.capturedPiece = null; // por si las moscas
        GameVars.selectedPiece.p = ChallengeManager.promotionEndPosition;
        ChallengeManager.onPieceArrivedToItsPosition();
    }

    public static onPieceArrivedToItsPosition(): void {

        if (GameVars.capturedPiece) {

            let board: Board = ChallengeState.currentInstance.board;
            board.removePiece(GameVars.capturedPiece);
            GameVars.capturedPieces.push(GameVars.capturedPiece.pieceType);     
        }

        // if (GameVars.currentTurn === GameVars.colorPlayer) {
        //     GameVars.levelMoves --;  
        //     ChallengeState.currentInstance.hud.updateMoves();
        // }

        if (GameVars.chess.in_check()) {
            ChallengeManager.check();
        } else if (ChallengeManager.kingInCheck) {
            ChallengeManager.uncheck();
        }

        // mirar si se ha producido jaque mate
        if (GameVars.chess.in_stalemate()) {
            ChallengeManager.stalemate();
        } else if (GameVars.chess.in_checkmate()) {
            ChallengeManager.checkmate();
        } else {

            // determinar el turno y grabar el estado
            ChallengeManager.setTurn();

            // poner un delay
            if (GameVars.currentTurn !== GameVars.colorPlayer) {
                if (GameVars.levelMoves === 0) {

                    if (GameVars.chess.in_check()) {

                        GameVars.useBotHint = false;
                        ChallengeManager.iaMove();
                        // pasado un tiempo
                        this.game.time.events.add(1000, function(): void {
                            ChallengeState.currentInstance.gameOver();
                        }, this);
                        
                    } else {
                        // inmediatamente
                        ChallengeState.currentInstance.gameOver();
                    }

                } else {
                    if (GameVars.chess.in_check()) {
                        this.game.time.events.add(2000, function(): void {
                            ChallengeManager.iaMove();
                        }, this);
                    } else {
                        ChallengeManager.iaMove();
                    }
                    
                }
            }
        }
    }

    private static iaMove(): void {

        let difficulty: number = 1;
        let delay: number = 0;

        switch (GameVars.difficulty) {
            case GameConstants.DIFFICULTY_EASY:
                difficulty = 1;
                delay = 350;
                break;
            case GameConstants.DIFFICULTY_MEDIUM:
                difficulty = 2;
                delay = 200;
                break;
            case GameConstants.DIFFICULTY_HARD:
                difficulty = 4;
                delay = 100;
                break;
            default:
                break;
        }

        // salimos de este thread y se pone el icono de pensar
        ChallengeManager.game.time.events.add(delay + 1000, function(): void {

            // hint
            if (GameVars.useBotHint) {

                let hints = GameVars.problemsData[GameVars.currentLevel].hints;

                let color = GameVars.colorPlayer === GameConstants.WHITE ? 1 : 0;

                let moveString = hints[GameVars.hintPos][color];

                let m: Move = GameVars.chess.move(moveString);

                ChallengeManager.p4State.move(m.from, m.to);

                ChallengeManager.game.time.events.add(350, function(): void {

                    let board: Board = ChallengeState.currentInstance.board;

                    // ver si se ha producido una promocion
                    let promotedPiece: string = ChallengeManager.checkIfPieceHasBeenPromoted(moveString);

                    // mirar si se ha capturado alguna pieza
                    ChallengeManager.checkIfPieceHasBeenCaptured(m, m.to);

                    // mover la pieza del tablero
                    GameVars.selectedPiece = board.getPieceAt(m.from);

                    board.moveSelectedPiece(m);

                }, ChallengeManager);  

            } else {
                
                let proposedMovement: number[] = ChallengeManager.p4State.findmove(difficulty);

                // convertir el movimiento propuesto a un string
                // para que chess y p4 puedan tomarlo como inputs
                let start: string = ChallengeManager.convertMovementToString(proposedMovement[0]);
                let end: string = ChallengeManager.convertMovementToString(proposedMovement[1]);
                
                ChallengeManager.p4Object = ChallengeManager.p4State.move(start, end);

                // se pone en un timer para evitar q el juego se quede parado
                ChallengeManager.game.time.events.add(350, function(): void {

                    let board: Board = ChallengeState.currentInstance.board;   
                    let moveString: string = ChallengeManager.p4Object.string;

                    // ver si se ha producido una promocion
                    let promotedPiece: string = ChallengeManager.checkIfPieceHasBeenPromoted(moveString);
        
                    // notificar a chess
                
                    let m: Move = GameVars.chess.move({from: start, to: end, promotion: promotedPiece});

                    // mirar si se ha capturado alguna pieza
                    ChallengeManager.checkIfPieceHasBeenCaptured(m, end);

                    // mover la pieza del tablero
                    GameVars.selectedPiece = board.getPieceAt(start);

                    board.moveSelectedPiece(m);

                }, ChallengeManager);  
            }
        }, ChallengeManager);
    }

    private static checkIfPieceHasBeenPromoted(movString: string): string {

        // encontrar la letra que hay inmediatamente despues de "=" si la hubiese
        let i: number = movString.indexOf("=");
        
        if (i !== -1) {

            let p: string = movString[i + 1];
            let ret: string;

            switch (p) {

                case "Q":
                    ret = GameConstants.BLACK_QUEEN;
                    break;

                case "B":
                    ret = GameConstants.BLACK_BISHOP;
                    break;
                
                case "R":
                    ret = GameConstants.BLACK_ROOK;
                    break;

                case "N":
                    ret = GameConstants.BLACK_KNIGHT;
                    break;
            
                default:
                    ret = null;
                    break;
            }

            return ret;

        } else {
            return null;
        }
    }

    private static convertMovementToString(mov: number): string {

        let col: number = mov % 10;
        let row: number =  Math.floor(mov / 10);

        let c: string  = GameConstants.COLUMNS[col - 1];
        let r: string = (row - 1).toString();

        return c + r;
    }

    private static checkIfPieceHasBeenCaptured(move: Move, endPosition: string): void {

        if (move === null) {
            return;
        }

        GameVars.capturedPiece = null;

        const board = ChallengeState.currentInstance.board;

        if (typeof move["captured"] !== "undefined") {

            let i = move.san.indexOf("x");
            let p = move.san.slice( i + 1, i + 3);

            GameVars.capturedPiece = board.getPieceAt(p);

            if (!GameVars.capturedPiece && (move.captured === GameConstants.BLACK_PAWN || move.captured === GameConstants.WHITE_PAWN)) {
                
                // se ha producido un EN PASSANT
                let p: string;
                let to: string = move.to;
                let row: number = parseInt(to[1]);

                if (move.color === GameConstants.WHITE) {
                    row --;
                } else {
                    row ++;
                }

                p = to[0] + row.toString();

                GameVars.capturedPiece = board.getPieceAt(p);
            }
        }

        // por si esto fallase usamos la endPosition
        if (!GameVars.capturedPiece) {
            GameVars.capturedPiece = board.getPieceAt(endPosition);
        }
    }

    private static stalemate(): void {

        GameVars.gameFinished = true;
        GameVars.stalemate = true;

        ChallengeState.currentInstance.gameOver();
    }

    private static checkmate(): void {
        
        ChallengeManager.uncheck();
        GameVars.gameFinished = true;

        if (GameVars.colorPlayer === GameVars.currentTurn) {
            ChallengeState.currentInstance.checkmate();
        } else {
            ChallengeState.currentInstance.gameOver();
        }
    }

    private static check(uploadedGame?: boolean): void {

        ChallengeManager.kingInCheck = true;
        ChallengeState.currentInstance.check(uploadedGame);
    }

    private static uncheck(): void {

        ChallengeManager.kingInCheck = false;
        ChallengeState.currentInstance.uncheck();
    }

    private static setTurn(): void {

        GameVars.fen = GameVars.chess.fen();

        // BoardManager.pushFenHistory();

        // para poder pillar los enroques, passant, etc...
        if (GameConstants.VERBOSE) {
            console.log(ChallengeManager.i, GameVars.fen);
        }
        
        ChallengeManager.i ++;

        let tmpArray: string[] = GameVars.fen.split("/");
        tmpArray = tmpArray[7].split(" ");
        GameVars.currentTurn = tmpArray[1];

        // hints
        if (GameVars.currentTurn === GameConstants.WHITE) {
            GameVars.hintPos++;
        }

        if (GameVars.currentTurn === GameVars.colorPlayer) {
            ChallengeState.currentInstance.gui.enableHint();
        }
    }

    private static checkPawnPromotion(end: string): boolean {

        // mirar si la fila es la 8 o la 1 y la pieza en cuestion es un peon
        if ((end[1] === GameConstants.ROWS[0] || end[1] === GameConstants.ROWS[7])
            && (GameVars.selectedPiece.pieceType === GameConstants.WHITE_PAWN || GameVars.selectedPiece.pieceType === GameConstants.BLACK_PAWN )) {
            return true;
        }

        return false;
    }
}
